var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainbody"},[_c('VueUeditorWrap',{attrs:{"destroy":true,"config":_vm.editorConfig},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('FootLayout',{attrs:{"leftTitle":"重置"},on:{"saveEdit":_vm.saveEdit,"leftFunction":_vm.leftFunction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19cb1fe7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLog/loginSetting.vue
// module id = null
// module chunks = 